// extracted by mini-css-extract-plugin
module.exports = {"root":"_72f376e","card":"_96f52b5","info":"_6e205e1","infoItems":"_ca6330e","infoWithSatellites":"_43bce84"};